<template>
    <div class="position-box">
        <div class="head">
          <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
          <div class="title">{{$t('xbsg.dy')}}</div>
        </div>
        <div class="cotainer subscribe">
            <ul class="ul-box">
              <li class="li">
                <div class="t1">{{$t('xbsg.fxjg')}}</div>
                <div class="t2">1 {{currency}} ≈ {{start_price}} USDT</div>
              </li>
              <li class="li issued">
                <div class="info-left">
                  <div class="t1">{{$t('xbsg.fxl')}}</div>
                  <div class="t2">{{make_amount}} {{currency}}</div>
                </div>
                <div class="info-right">
                  <div class="t1">{{$t('xbsg.syl')}}</div>
                  <div class="t2">{{has_amount}} {{currency}}</div>
                </div>
              </li>
              <li class="li">
                <div class="t1">{{$t('xbsg.ssrq')}}</div>
                <div class="t2 time">{{start_time_format}}</div>
              </li>
              <li class="li">
                <div class="t1">{{$t('xbsg.yxqx')}}</div>
                <div class="t2 time">{{yxq_start}} - {{yxq_end}} </div>
              </li>
              <li class="li num-box">
                <div class="t1">{{currency}}</div>
                <div class="t2 num"><input class="input number" type="number" v-model="amount" @keyup="keyMoney()" :placeholder="$t('xbsg.qsrsl')"></div>
              </li>
              <li class="li btn-box">
                <button id="order" class="btn btn-bg" type="button" @click="submit">{{$t('xbsg.xzjdy')}}</button>
              </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'subscribe',
    data () {
        return {
            theme: false,
            token: '',
            id: '',
            currency: '',
            start_price: '',
            make_amount: '',
            has_amount: '',
            start_time_format: '',
            yxq_start: '',
            yxq_end: '',
            amount: '',
            useBalance: '',
            count: 1
        }
    },
    created(){
      this.id = this.$route.query.id;
      this.token = localStorage.getItem('token') || '';
    },
    mounted() {
        this.getNewcoinsList()
    },
    methods: {
       back(){
           this.$router.push('/subscription')
       },
       getNewcoinsList(){
            let params = {
               id: this.id
            }
            this.$ajax.get('/web/getNewcoinsInfo',{params}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  setTimeout(()=>{
                    this.$router.push('/index');
                  },1000)
                  return false
                }
                this.currency = resData.currency;
                this.start_price = resData.start_price;
                this.make_amount = resData.make_amount;
                this.has_amount = resData.has_amount;
                this.start_time_format = resData.start_time_format;
                this.yxq_start = resData.yxq_start_format;
                this.yxq_end = resData.yxq_end_format;

            }).catch(function(err){
                console.log(err)
            })
        },
        submit(){
            let params = {
                token: this.token,
                id: this.id,
                amount: this.amount
            }
            if(!this.amount || this.amount <= 0){
                this.$toast.center(this.$t('xbsg.qsrsl'));
                return;
            }
            if(this.count == 1){
                this.count = 0;
            }else{
                return false;
            }
            this.$ajax.get('/web/buyNewcoins',{params}).then((res) => {
                let resData = res.data;
                if(resData.code == 1){
                    this.count = 1;
                    this.$toast.center(resData.message);
                    setTimeout(()=>{
                      this.count = 1;
                      this.$router.push('/subscription')
                    },1000)
                }else if(resData.code == 1000){
                    this.$toast.center(resData.message);
                }else{
                    setTimeout(()=>{
                        this.count = 1;
                        this.$router.push('/subscriptionList')
                    },1000)
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        keyMoney(){//输入数量规则
            var amount =  $('.number').val();
            amount = amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
            amount = amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
            amount = amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
            amount = amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
            if (amount.indexOf(".") < 0 && amount != "") { //首位是0的话去掉
                amount = parseFloat(amount)
            }
            $('.number').val(amount)
        }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
.position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 1.2rem;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        padding: 0 .44rem;
        color: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .32rem;
        margin-top: -.3rem;
    }
    .head .title{
        font-size: .52rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .head .link{
        position: absolute;
        top: 50%;
        right: .3rem;
        padding: .12rem .36rem;
        color: #4489D7;
        font-size: .38rem;
        border: 1px solid #4489D7;
        border-radius: 3px;
        transform: translateY(-50%);
    }
    .cotainer{
        position: absolute;
        left: .42rem;
        right: .42rem;
        top: 1.5rem;
        bottom: 0;
        overflow-y: scroll;
    }
    .ul-box{
        padding: 0 .45rem;
        background: rgba(41,55,68,.2);
        border-radius: .27rem;
    }
    .ul-box .li{
        padding-bottom: .3rem;
        border-bottom: 1px solid #858585;
    }
    .ul-box .li.issued{
        display: flex;
        align-items: center;
    }
    .ul-box .li.issued .info-left{
        margin-right: 1.44rem;
    }
    .ul-box .li .t1{
        padding: .6rem 0 .46rem;
        color: #fff;
        font-size: .48rem;
    }
    .ul-box .li .t2{
        color: #4489D7;
        font-size: .39rem;
        font-weight: bold;
    }
    .ul-box .li .t2.time{
        color: #fff;
        font-weight: 400;
    }
    .ul-box .li .input{
        padding: 0 .66rem;
        color: #fff;
        font-size: .42rem;
        background: transparent;
    }
    .ul-box .li.num-box{
        display: flex;
        align-items: center;
        padding: .72rem 0 .42rem;
    }
    .ul-box .li.num-box .t1{
        padding: 0;
    }
    .ul-box .li:last-child{
        border-bottom: none;
    }
    .ul-box .li .btn{
        display: block;
        width: 100%;
        margin: 1.68rem 0 1.14rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/subscribe.vue